import { render } from "./OrderInfoView.vue?vue&type=template&id=936b2b98"
import script from "./OrderInfoView.vue?vue&type=script&lang=js"
export * from "./OrderInfoView.vue?vue&type=script&lang=js"

import exportComponent from "d:\\projekty\\www\\cdif3com\\rental\\source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__